<template>
	<div
		class="mx-[2px] min-w-48 max-w-[200px] flex-shrink-0 rounded-xl border border-gray-300 bg-white px-3 py-2"
	>
		<!-- Planting Header -->
		<div class="mb-2 flex items-center justify-between gap-2">
			<h4
				class="m-0 overflow-hidden whitespace-normal break-words text-sm font-semibold text-gray-900"
			>
				{{ planting.name }}
			</h4>
			<ion-label
				:class="[
					'rounded-full px-2 !text-sm font-bold',
					plantingStatusBackgroundClass(planting.status),
					plantingStatusTextClass(planting.status),
				]"
			>
				{{ planting.statusText }}
			</ion-label>
		</div>

		<!-- Planting Details -->
		<div class="space-y-1 text-xs text-gray-700">
			<div v-if="planting.commodityCurrent">
				<span class="font-medium">{{ t("common.commodity") }}</span>
				{{ planting.commodityCurrent }}
			</div>

			<div>
				<span class="font-medium">{{ t("common.acres") }}</span>
				{{ planting.acresCurrent }}
			</div>

			<div v-if="planting.bedCountCurrent != null">
				<span class="font-medium">{{ t("common.bed-count") }}</span>
				{{ planting.bedCountCurrent }}
			</div>

			<div>
				<span class="font-medium">{{ t("common.wet-date") }}</span>
				{{ formatDateString(planting.wetDateCurrent) }}
			</div>

			<div>
				<span class="font-medium">{{ t("common.harvest-date") }}</span>
				{{ formatDateString(planting.endDate) }}
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
	import { IonLabel } from "@ionic/vue";
	import type { PlantingDTO } from "seedgreen-shared/dtos/PlantingDTO";
	import {
		plantingStatusBackgroundClass,
		plantingStatusTextClass,
	} from "@/utils/planting";
	import { formatDateString } from "@/utils/date";
	import { useI18n } from "vue-i18n";

	const { t } = useI18n();

	interface Props {
		planting: PlantingDTO;
	}

	defineProps<Props>();
</script>
